import { IntentInterface } from 'types';

export const intentDecorator = ({ intent }: IntentInterface, bg = true) => {
	const rule = bg ? 'background' : 'color';
	return intent ? `${rule}: var(--${intent});` : '';
};
